<template>
  <Swiper
    :modules="[Navigation, Pagination, A11y, Autoplay]"
    :slides-per-view="1"
    :space-between="50"
    :navigation="slides.length > 1 && !isMobile"
    :pagination="slides.length > 1 ? { clickable: true } : false"
    :autoplay="slides.length > 1 ? { delay: 6000 } : false"
    class="block-carousel h-[calc(100vh-180px)]"
  >
    <SwiperSlide
      v-for="slide in slides"
      :key="slide.id"
      class="relative h-full w-full"
    >
      <!-- Image -->
      <NuxtImg
        v-if="slide.mobileImage[0]"
        :src="getCmsImage(slide.mobileImage)"
        format="webp"
        loading="lazy"
        alt=""
        class="h-full w-full object-cover sm:hidden"
      />
      <NuxtImg
        :src="getCmsImage(slide.images)"
        format="webp"
        loading="lazy"
        alt=""
        class="h-full w-full object-cover"
      />

      <!-- Overlay Content -->
      <div class="absolute inset-0 px-12 py-12 flex items-center bg-black/40">
        <v-container>
          <div class="text-white mx-auto w-full">
            <div v-if="slide.label" class="font-semibold uppercase tracking-[0.2em] mb-2 text-base md:text-xl">
              {{ slide.label }}
            </div>
            <h2 class="text-3xl sm:text-5xl font-bold mb-4 max-w-4xl">
              {{ slide.heading }}
            </h2>
            <div v-html="slide.body" class="prose text-white text-lg max-w-lg mb-6">
            </div>

            <VButton
              v-if="slide.callToAction?.element"
              size="lg"
              :href="'/' + (locale + '/') + slide.callToAction.element.slug"
            >
              {{ slide.callToAction.label }}
            </VButton>
            <VButton
              as="a"
              size="lg"
              v-else-if="slide.callToAction?.url"
              :href="slide.callToAction.url"
            >
              {{ slide.callToAction.label }}
            </VButton>
          </div>
        </v-container>
      </div>
    </SwiperSlide>
  </Swiper>
</template>

<script lang="ts" setup>
import { getCmsImage } from '@/composables/useCms';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules';
import {useMediaQuery} from "@vueuse/core";

interface Slide {
  id: string;
  heading: string;
  label?: string;
  body: string;
  images: {
    title: string;
    url: string;
  }[];
  mobileImage: {
    title: string;
    url: string;
  }[];
  callToAction: {
    text: string;
    customText: string;
    url: string;
    label?: string;
    element?: {
      slug: string;
    };
  };
}

withDefaults(
  defineProps<{
    heading?: string | null;
    slides: Slide[];
  }>(),
  {
    slides: () => [],
  },
);

const localePath = useLocalePath();
const { t, locale } = useI18n();
const isMobile = useMediaQuery('(max-width: 640px)');
</script>